<!-- eslint-disable vue/no-parsing-error -->
<template>
  <b-card-code>
    <b-row>
      <b-col
        lg="6"
        md="6"
        cols="12"
      >
        <b-form-group v-if="!userData.partner">
          <label for="partner"
            >Choose Partner: <span class="text-danger">*</span></label
          >
          <v-select
            id="partner"
            v-model="formPayload.partner"
            :options="options.partner"
            :reduce="(item) => item.uuid"
            label="name"
            placeholder="Type to search Partner..."
            @search="onSearchPartner"
          >
            <template slot="no-options">
              Type here to search partner...
            </template>
          </v-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="formPayload.partner">
      <b-col
        lg="6"
        md="6"
        cols="12"
      >
        <p class="h4">Menu Structure</p>
      </b-col>
    </b-row>
    <ComponentDrag v-if="formPayload.partner">
      <div class="side-by-side">
        <!-- <div class="side pl-0">
          <VueNestable
            v-model="nestableItems1"
            cross-list
            group="cross"
            :maxDepth="1"
          >
            <VueNestableHandle
              slot-scope="{ item }"
              :item="item"
            >
              <span class="nested-item">
                <feather-icon
                  icon="MenuIcon"
                  size="18"
                />
                {{ item.title }}
              </span>
            </VueNestableHandle>
          </VueNestable>
        </div> -->
        <div class="side pl-1">
          <VueNestable
            v-model="nestableItems2"
            cross-list
            group="cross"
            :maxDepth="4"
          >
            <VueNestableHandle
              slot-scope="{ item }"
              :item="item"
            >
              <span class="nested-item">
                <feather-icon
                  icon="MoveIcon"
                  size="18"
                  class=""
                />
                {{ item.title }}
                <div>
                  <div
                    :class="item.is_active ? 'bg-success' : 'bg-danger'"
                    style="width: 8px; height: 8px; border-radius: 50%"
                  ></div>
                </div>
              </span>
            </VueNestableHandle>
          </VueNestable>
        </div>
      </div>
    </ComponentDrag>
  </b-card-code>
</template>

<script>
import _ from 'lodash';
import BCardCode from '@core/components/b-card-code/BCardCode.vue';
import {
  BCard,
  BCardText,
  BButton,
  BSpinner,
  BFormGroup,
  BFormInput,
  BFormFile,
  BRow,
  BCol,
  BForm,
  BFormTextarea,
  BImg,
  BFormSelect,
  BFormCheckbox,
} from 'bootstrap-vue';
import { heightTransition } from '@core/mixins/ui/transition';
import Ripple from 'vue-ripple-directive';

import { successNotification, errorNotification } from '@/auth/utils';
import FormTextarea from '@/components/FormTextarea.vue';
import FormInput from '@/components/FormInput.vue';
import FormSelect from '@/components/FormSelect.vue';
import vSelect from 'vue-select';

import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';

import ComponentDrag from '@/components/ComponentDrag.vue';
import { VueNestable, VueNestableHandle } from 'vue-nestable';
import { filter } from 'lodash';

export default {
  title() {
    return 'Navbar Mapping';
  },
  components: {
    BFormGroup,
    BCard,
    BButton,
    BCardText,
    BCardCode,
    BSpinner,
    BFormInput,
    BFormFile,
    BRow,
    BCol,
    BForm,
    BFormTextarea,
    BImg,
    FormSelect,
    FormTextarea,
    FormInput,
    AppCollapse,
    AppCollapseItem,
    vSelect,
    BFormSelect,
    BFormCheckbox,

    VueNestable,
    VueNestableHandle,
    ComponentDrag,
  },
  directives: {
    Ripple,
  },
  setup() {
    return { successNotification, errorNotification };
  },
  mixins: [heightTransition],
  watch: {},
  computed: {},
  data() {
    const userData = JSON.parse(localStorage.getItem('userData'));
    return {
      userData,
      formPayload: {
        is_active: false,
        title: null,
        location: null,
        content: null,
        partner: userData?.partner?._id || null,
      },

      isLoading: false,
      imageUrl: null,
      mainProps: {
        blank: true,
        width: 25,
        height: 25,
      },
      validations: {},
      options: {
        partner: [],
      },
      editId: null,
      nestableItems1: [],
      nestableItems2: [],
    };
  },
  watch: {
    'formPayload.partner': {
      handler(partner_uuid) {
        this.getNavbar();
        this.getNavbarMapping();
      },
      deep: true,
    },
    nestableItems2: {
      handler: _.debounce(function (value) {
        this.updatePositions();
      }, 1000),
      deep: true,
    },
  },
  mounted() {
    this.getPartner();

    if (this.formPayload.partner) {
      this.getNavbar();
      this.getNavbarMapping();
    }
  },
  created() {},
  destroyed() {},
  methods: {
    /**
     * Recursively traverse a nested array of objects and return an array of all elements,
     * without their children property.
     * @param {array} data - Nested array of objects
     * @returns {array} - Flattened array of objects
     */
    flattenData(data) {
      let result = [];

      function extractChildren(items) {
        for (const item of items) {
          result.push({ ...item, children: undefined }); // Copy item without children
          if (item.children && item.children.length > 0) {
            extractChildren(item.children); // Recursively process children
          }
        }
      }

      extractChildren(data);
      return result;
    },
    /**
     * Updates the positions of the items in the nestable component.
     *
     * Updates the positions of the items in the nestable component based on their index in the array.
     * Also updates the parent of the items if it has changed.
     * If the item has children, it recursively updates the positions of the children.
     * After updating the positions, it checks if the parent or position of the items has changed and
     * if so, it calls the updateItem function to update the item in the server.
     * @returns {undefined}
     */
    updatePositions() {
      // Clone the original state before updating
      const originalFlatData = this.flattenData(this.nestableItems2).map(
        (item) => ({
          ...item,
        })
      );

      /**
       * Recursively updates the positions and parents of the items in the nestable component.
       *
       * @param {array} items - Items to update
       * @param {string} [parentId=null] - The parent id of the items
       * @param {number} [depth=1] - The current depth of the nested children
       * @returns {undefined}
       */
      const updateParent = (items, parentId = null, depth = 1) => {
        items.forEach((item, index) => {
          const newParent = depth === 1 ? null : parentId;

          if (item.parent !== newParent) {
            this.$set(item, 'parent', newParent); // Update parent only if changed
          }

          item.position = index + 1; // Update position based on index

          if (item.children && item.children.length > 0) {
            updateParent(item.children, item._id, depth + 1);
          }
        });
      };

      updateParent(this.nestableItems2);

      const updatedFlatData = this.flattenData(this.nestableItems2);

      updatedFlatData.forEach((newItem, index) => {
        if (
          originalFlatData[index].parent !== newItem.parent ||
          originalFlatData[index].position !== newItem.position
        ) {
          this.updateItem(newItem);
        }
      });
    },
    async getNavbar() {
      try {
        const response = await this.$http.get(
          `/admin/navbar/partner/${this.formPayload.partner}`
        );
        this.nestableItems1 = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getNavbarMapping() {
      try {
        const response = await this.$http.get(
          `/admin/navbar/partner/${this.formPayload.partner}/mapping`
        );
        this.nestableItems2 = response.data.data;
        // this.updatePositions();
      } catch (error) {
        console.log(error);
      }
    },
    cleanUpForm() {
      this.editId = null;
      this.formPayload = {
        is_active: false,
        title: null,
        location: null,
        content: null,
        partner: null,
      };
    },
    updateItem(data) {
      const qs = require('qs');
      const formData = {};

      if (data.title) formData.title = data.title;
      if (data.link_type) formData.link_type = data.link_type;
      if (data.link_type === 'category' && data.post_category)
        formData.post_category = data.post_category._id;
      if (data.page?._id) formData.page = data.page._id;
      if (data.url) formData.url = data.url;
      if (data.is_active !== undefined) formData.is_active = data.is_active;
      if (data.position !== undefined) formData.position = data.position;
      if (data.partner?._id) formData.partner = data.partner._id;
      if (data.parent) formData.parent = data.parent; // Only set if not null/undefined

      const form = qs.stringify(formData);

      this.$http
        .patch(`/admin/navbar/${data._id}`, form, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((response) => {})
        .catch((error) => {
          const validations = error.response.data.meta.validations;
          const messages = error.response.data.meta.messages;
          // this.validations = validations
          if (validations) {
            for (const key in validations) {
              if (validations.hasOwnProperty(key)) {
                errorNotification(
                  this,
                  'Oops!',
                  key + ' ' + validations[key].join(', ')
                );
              }
            }
          }
          if (messages) {
            errorNotification(this, 'Oops!', messages);
          }
        });
    },
    preparePayloadQs() {
      const qs = require('qs');
      // Create a new object to store the filtered payload
      const filteredPayload = Object.keys(this.formPayload)
        .filter(
          (key) => this.formPayload[key] != null && this.formPayload[key] !== ''
        )
        .reduce((acc, key) => {
          // Handle the 'partner' key separately
          if (key === 'partner') {
            acc[key] =
              typeof this.formPayload.partner !== 'object'
                ? this.formPayload.partner
                : this.formPayload.partner._id;
          }
          // else if (key === 'content') {
          //     const formattedContent = this.removeScriptTags(this.formPayload.content)
          //     acc[key] = formattedContent
          // }
          else {
            acc[key] = this.formPayload[key];
          }
          return acc;
        }, {});

      // Use qs to stringify the payload
      const queryString = qs.stringify(filteredPayload, {
        arrayFormat: 'brackets',
      });

      return queryString;
    },
    preparePayload() {
      const form = new FormData();
      for (const key in this.formPayload) {
        if (
          this.formPayload.hasOwnProperty(key) &&
          this.formPayload[key] != null &&
          this.formPayload[key] != ''
        ) {
          const partner =
            typeof this.formPayload.partner != 'object'
              ? this.formPayload.partner
              : this.formPayload.partner._id;
          if (key != 'partner') {
            form.append(key, this.formPayload[key]);
          }
          if (key == 'partner') {
            form.append(key, partner);
          }
          // if (key == 'content') {
          //     const formattedContent = this.removeScriptTags(this.formPayload.content)
          //     form.append(key, formattedContent)
          // }
        }
      }

      return form;
    },
    // Partner
    onSearchPartner(search, loading) {
      if (search.length) {
        loading(true);
        this.searchPartner(loading, search, this);
      }
    },
    searchPartner: _.debounce((loading, search, vm) => {
      vm.$http
        .get(`admin/partners?&search=${encodeURI(search)}`)
        .then((response) => {
          vm.options.partner = response.data.data.items.map((obj) => ({
            uuid: obj._id,
            name: obj.name,
          }));
        })
        .catch((error) => {
          console.error(error);
        });
      loading(false);
    }, 300),
    getPartner() {
      if (this.userData.role == 'admin') {
        this.$http
          .get('/admin/partners', {})
          .then((result) => {
            console.log(result, 'result');
            this.options.partner = result.data.data.items.map((obj) => ({
              uuid: obj._id,
              name: obj.name,
            }));

            console.log(this.options.partner, 'this.options.partner');
          })
          .catch((err) => {});
      }
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.adsbygoogle {
  height: -webkit-fill-available;
}

.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.vs__dropdown-menu {
  position: relative;
  margin-top: 10px;
}
</style>
